module.exports = global["_"] = require("-!/home/proteore/galaxy/client/node_modules/expose-loader/index.js?underscore!./underscore.js");